<template>
  <node-view-wrapper class="add-transparent-border">
    <vuetify-audio
      :file="node.attrs.file"
      :color="node.attrs.color"
      :pathaudio="node.attrs.pathAudio"
      flat
      class="audio-wrapper"
      :type="node.attrs.type"
      :title="node.attrs.title"
    />
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-2'
export default {
  components: {
    NodeViewWrapper
  },
  props: nodeViewProps,
}
</script>
